export const GET_TOTAL_STATS = 'BILLS/get_total_stats';
export const GET_GRAPH_STATS = 'BILLS/get_graph_stats';
